import { render, staticRenderFns } from "./ManualShiftAssignment.vue?vue&type=template&id=65797d90"
import script from "./ManualShiftAssignment.vue?vue&type=script&lang=js"
export * from "./ManualShiftAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports